module.exports = __webpack_public_path__ + "static/media/preview-icon.182140b1.svg";